function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getHorizontalStyle = function getHorizontalStyle(token) {
  var _$concat;

  var componentCls = token.componentCls,
      motionDurationSlow = token.motionDurationSlow,
      menuHorizontalHeight = token.menuHorizontalHeight,
      colorSplit = token.colorSplit,
      lineWidth = token.lineWidth,
      lineType = token.lineType,
      menuItemPaddingInline = token.menuItemPaddingInline;
  return _defineProperty({}, "".concat(componentCls, "-horizontal"), (_$concat = {
    lineHeight: "".concat(menuHorizontalHeight, "px"),
    border: 0,
    borderBottom: "".concat(lineWidth, "px ").concat(lineType, " ").concat(colorSplit),
    boxShadow: 'none',
    '&::after': {
      display: 'block',
      clear: 'both',
      height: 0,
      content: '"\\20"'
    }
  }, _defineProperty(_$concat, "".concat(componentCls, "-item, ").concat(componentCls, "-submenu"), {
    position: 'relative',
    display: 'inline-block',
    verticalAlign: 'bottom',
    paddingInline: menuItemPaddingInline
  }), _defineProperty(_$concat, "> ".concat(componentCls, "-item:hover,\n        > ").concat(componentCls, "-item-active,\n        > ").concat(componentCls, "-submenu ").concat(componentCls, "-submenu-title:hover"), {
    backgroundColor: 'transparent'
  }), _defineProperty(_$concat, "".concat(componentCls, "-item, ").concat(componentCls, "-submenu-title"), {
    transition: ["border-color ".concat(motionDurationSlow), "background ".concat(motionDurationSlow)].join(',')
  }), _defineProperty(_$concat, "".concat(componentCls, "-submenu-arrow"), {
    display: 'none'
  }), _$concat));
};

export default getHorizontalStyle;